module.exports = __webpack_public_path__ + "static/media/teacherImage.2e585cbb.jpg";